export function getMinDistanceByZoom(
  zoomMap: number,
  mapType: 'google' | 'leaflet' = 'google'
): number {
  if (mapType === 'leaflet') {
    if (zoomMap >= 19) {
      return 0
    } else if (zoomMap >= 18 && zoomMap < 19) {
      return 15
    } else if (zoomMap >= 17 && zoomMap < 18) {
      return 25
    } else if (zoomMap >= 16 && zoomMap < 17) {
      return 35
    } else if (zoomMap >= 15 && zoomMap < 16) {
      return 45
    } else if (zoomMap >= 14 && zoomMap < 15) {
      return 55
    } else if (zoomMap >= 13 && zoomMap < 14) {
      return 100
    } else {
      return 999
    }
  } else {
    // Google Maps specific zoom levels
    if (zoomMap < 15) {
      return 999
    } else if (zoomMap >= 15 && zoomMap < 17) {
      return 35
    } else if (zoomMap >= 17 && zoomMap < 18) {
      return 33
    } else if (zoomMap >= 18 && zoomMap < 21) {
      return 25
    } else {
      return 0
    }
  }
}
